<div class="quill-material-container" #container>
     <div id="toolbar">
          <button class="ql-list" value="bullet"></button>
          <button class="ql-link"></button>
     </div>
     @if (customLinkHandlerData !== null) {
         <link-creator [linkDetails]="customLinkHandlerData" (resultlinkDetailEvent)="closeCustomLinkHandler($event)"></link-creator>
     }
     <div id="editor" (click)="onTouched()"></div>
</div>